import axios from "axios";

export const CreateTrust = async (payload, token) => {
    try {
        const response = await axios.post(
            'trust/admin/create-trust/',
            payload,
            {
                headers: {
                    Authorization: `Bearer ${token}`,
                    'Content-Type': 'application/json',
                },
            }
        );
        return response.data;
    } catch (error) {

        throw error?.response?.data || error;
    }
};


export async function uploadFile(token, body) {
    const UPLOAD_API_URL = 'trust/admin/trust-upload-file/'
    const formData = new FormData();
    const { trust_name, file, file_password
    } = body;
    formData.append('trust_name', trust_name);
    // formData.append('file_password', file_password);
    formData.append('file', file?.originFileObj); 
    // return;
   
    try {
        const response = await axios.post(UPLOAD_API_URL, formData, {
            headers: {
                "Content-Type": "multipart/form-data",
                Authorization: token
            },
        });

      
        return response?.data;
    } catch (error) {

        return error;
    }

}